import { MainLayout } from "@/layout";
import { chineseMedicineRoute,chineseMedicineDetailsRoute } from "@/config/RouteConfig";

const chineseMedicine = {
  path: "",
  component: MainLayout,
  children: [
    {
      ...chineseMedicineRoute,
      component: () => import("@/views/ChineseMedicine"),
    },
    {
      ...chineseMedicineDetailsRoute,
      component: () => import("@/views/ChineseMedicineDetails"),
    },
  ],
};

export default chineseMedicine;
